export const TEXT_TAB = '@/TEXT_TAB';
export const CODE_TAB = '@/CODE_TAB';
export const IMAGE_TAB = '@/IMAGE_TAB';
export const SYMBOL_TAB = '@/SYMBOL_TAB';
export const AUTOFILL_TAB = '@/AUTOFILL_TAB';
export const MATRIX_TAB = '@/MATRIX_TAB';